// How the footer and the settings page reopen the cookie preferences without importing the banner
// (and with it the tracker code): the banner listens for this window event, see CookieConsent.tsx.
export const OPEN_COOKIE_SETTINGS_EVENT = "stippl:open-cookie-settings";
export const COOKIE_SETTINGS_HASH = "#cookie-settings";

// Where to go when no banner is mounted on this page. The SSR marketing entry mounts none, and on
// stippl.io it also renders /privacy and /terms, so neither can host the banner. /disclaimer is a
// plain SPA route on every host.
const FALLBACK_PATH = "/disclaimer";

export function openCookieSettings(): void {
	const detail = { handled: false };
	window.dispatchEvent(new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT, { detail }));
	if (!detail.handled) window.location.assign(`${FALLBACK_PATH}${COOKIE_SETTINGS_HASH}`);
}
